import { api } from "../api";

/**
 * commandUpdateStatusById - Function that updates on database an personalized protocol command status by id  
 * /commands/{id}/{status}   
 * method PUT 
 * @async-function
 */
const commandUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/commands/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};

export default commandUpdateStatusById;
